import React from 'react';
import PricingSection from '../components/Home/PricingSection';

const SignupPage: React.FC = () => {
  return (
    <div className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header removed to save vertical space */}
        <PricingSection />
      </div>
    </div>
  );
};

export default SignupPage;
